export default __webpack_public_path__ + "static/media/logo.a5cd3d87.svg";